export default __webpack_public_path__ + "static/apparel-rfqs-buyer-view-1f51c905db3c1fc59f6dba448597464a.png";